import React from "react";
import {Layout} from "layouts";
import AwardsHeader from "@/components/awards/awards-header";
import AwardsContent from "@/components/awards/awards-content";

const Awards: React.FC = () => {
    return (
        <Layout page={"awards"}>
            <AwardsHeader/>
            <AwardsContent/>
        </Layout>
    )
};

export default Awards;
